import { render, staticRenderFns } from "./PreroastingSettings.vue?vue&type=template&id=98a07e06&scoped=true&"
import script from "./PreroastingSettings.vue?vue&type=script&lang=ts&"
export * from "./PreroastingSettings.vue?vue&type=script&lang=ts&"
import style0 from "./PreroastingSettings.vue?vue&type=style&index=0&id=98a07e06&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a07e06",
  null
  
)

export default component.exports